import { DeliveryOrderApi } from '../../../../api/Purchase/DeliveryOrder'
import { OrdersApi } from '../../../../api/Purchase/Orders'
import Packing from '../../../../components/Purchasing/Order/PackingList/Packing'
import useFetchList from '../../../../elements/Hooks/useFetchList'
import React, { useState } from 'react'

function PackingCont(props) {
  const { order, delivery } = props

  let { list, fetching, fetch } = useFetchList(() =>
    delivery ? DeliveryOrderApi.getPackingByOrder(delivery._key) : OrdersApi.getPackingByOrder(order._key)
  )

  const [clicked, setClicked] = useState('')

  return (
    <Packing
      {...{
        clicked,
        setClicked,
        list,
        fetching,
        fetch,
        order: order || delivery,
      }}
    />
  )
}

export default PackingCont
